import React from 'react';

const VECIHeader = ({ currentStepLabel, step, totalSteps, progress }) => (
  <div className='card border-0 shadow-sm mb-4 overflow-hidden rounded-4'>
    <div className='card-body p-4 bg-primary text-white position-relative'>
      <div className='position-relative z-1'>
        <h2 className='fw-bold mb-1'>Survey Daya Saing BUMDes (VECI)</h2>
        <p className='opacity-75 mb-0 small'>
          Village-owned Enterprises Competitiveness Index • Program Peningkatan
          Daya Saing
        </p>
      </div>
      <div className='position-absolute top-0 end-0 p-4 opacity-25'>
        <i className='bi bi-graph-up-arrow display-1'></i>
      </div>
    </div>
    <div className='bg-light p-3'>
      <div className='d-flex justify-content-between align-items-center mb-2'>
        <span className='badge bg-primary-subtle text-primary border border-primary-subtle px-3 py-2 rounded-pill'>
          {currentStepLabel}
        </span>
        <span className='text-muted small'>
          Step {step} of {totalSteps}
        </span>
      </div>
      <div
        className='progress rounded-pill'
        style={{ height: '8px' }}
      >
        <div
          className='progress-bar progress-bar-striped progress-bar-animated bg-primary'
          role='progressbar'
          style={{ width: `${progress}%` }}
        ></div>
      </div>
    </div>
  </div>
);

export default VECIHeader;
